<template>
  <pagefra>
    <div class="externalSystem fullscreen container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form :inline="true" v-model="form" class="toolbar-form">
            <el-form-item :label="$l('系统名称')">
              <el-input
                v-model="form.systemName"
                maxlength="30"
                :placeholder="$l('系统名称')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd()"
              v-show="hasPermission('新增')"
              >{{ $l("新增") }}
            </el-button>
            <el-button
              icon="el-icon-delete"
              round
              @click="deleteSystem"
              v-show="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="systemName"
              :label="$l('系统名称')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="systemKey"
              :label="$l('系统密钥')"
              min-width="180"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="disabled"
              :label="$l('是否启用')"
              min-width="60"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.disabled" style="color: red"
                  >{{ $l("否") }}
                </span>
                <span v-else style="color: green">{{ $l("是") }} </span>
              </template>
            </el-table-column>
            <el-table-column
              property="creator"
              :label="$l('创建者')"
              min-width="100"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="createDate"
              :label="$l('创建时间')"
              min-width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="80"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        :title="$l(editDialogTitle)"
        :visible.sync="editDialogVisible"
        @closed="closeEditDialog"
        width="640px"
      >
        <el-form
          ref="editForm"
          :model="editForm"
          :rules="rules"
          label-width="140px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('系统名称')" prop="systemName">
            <el-input v-model="editForm.systemName"></el-input>
          </el-form-item>
          <el-form-item :label="$l('系统密钥')" prop="systemKey">
            <el-input
              v-model="editForm.systemKey"
              disabled
              style="width: 320px"
            ></el-input
            >&nbsp;&nbsp;
            <el-button type="success" @click="getKey">{{
              $l("生成")
            }}</el-button>
          </el-form-item>
          <el-form-item :label="$l('是否启用')">
            <el-switch
              v-model="editForm.disabled"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="editDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submit"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";

export default {
  name: "externalSystem",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateSystemName = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入系统名称")));
      } else {
        callback();
      }
    };
    return {
      form: {
        systemName: "",
      },
      editDialogVisible: false,
      editDialogTitle: "",
      editForm: {
        systemId: null,
        systemName: "",
        systemKey: "",
        disabled: true,
      },
      rules: {
        systemName: [
          {
            required: true,
            message: this.$l("请输入系统名称"),
            trigger: "blur",
          },
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
          { validator: validateSystemName, trigger: "blur" },
        ],
        systemKey: [
          {
            required: true,
            message: this.$l("请输入系统密钥"),
            trigger: "blur",
          },
        ],
      },
      tableData: null,
      loading: false,
      selectedList: [],
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    showAdd() {
      this.editDialogTitle = "新建第三方系统信息";
      this.editDialogVisible = true;
      this.editForm.systemId = null;
      for (let key in this.editForm) {
        this.editForm[key] = null;
      }
      this.editForm["disabled"] = true;
    },
    showEdit(row) {
      this.editDialogTitle = "编辑第三方系统信息";
      this.editDialogVisible = true;
      this.$http
        .get(this.$apiConfig.get_external_system_url + row.systemId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (let key in this.editForm) {
              this.editForm[key] = result.data[key];
            }
            this.editForm.disabled = !this.editForm.disabled;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    getKey() {
      const systemName = this.editForm.systemName;
      if (systemName == null || systemName.trim() == "") {
        this.message(1, "请先输入系统名称");
        return;
      }
      this.$http
        .get(this.$apiConfig.get_external_system_key_url, {
          params: {
            systemName: systemName,
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.editForm.systemKey = result.data;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_external_system_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        const params = JSON.parse(JSON.stringify(this.editForm));
        params.disabled = !params.disabled;
        if (valid) {
          this.$http
            .post(this.$apiConfig.save_external_system_url, params)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.editDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteSystem() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let systemIdList = [];
        for (let i = 0; i < len; i++) {
          systemIdList.push(this.selectedList[i].systemId);
        }
        let formData = new FormData();
        formData.append("systemIdList", systemIdList);
        this.$http
          .post(this.$apiConfig.delete_external_system_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(3);
            this.$sentry.captureException(error);
          });
      });
    },
    closeEditDialog() {},
  },
};
</script>
<style scoped lang="scss">
.dialog-form {
  .el-input {
    width: 400px;
  }
}
</style>
